import HeaderContainer from "./HeaderContainer";
import HeaderActions from "./HeaderActions";
import HeaderAccount from "./HeaderAccount";
import HeaderNotification from "./HeaderNotification";
import "./header.scss";

// Public Header API (backward compatible):
// - Text / title: centered heading.
// - LinkR / LinkL: route path (e.g. "/Cars") or -1 for history-back.
//   Use -1 when a page has more than one parent (e.g. UserPanel is reachable
//   from "/" and "/ServiceDashbord") so the back button preserves the user's
//   actual flow instead of hardcoding a possibly-wrong page.
// - BackFallback: route used when -1 has no history to go back to.
// - LeftIcon: optional override for the left-slot glyph (URL string or node).
// - hideR / hideL: legacy visibility flags ("hide" hides an empty slot).
// - showNotification / notificationTo / notificationLabel: notifications
//   entry on the end slot (default). Shown whenever the end slot has no
//   explicit LinkL target, so root pages get a notification shortcut with a
//   live unread badge while sub-pages keep their custom action.
// - showAccount / accountTo / accountLabel: opt-in account entry on the end
//   slot. Takes precedence over the notification entry when enabled; the
//   account page itself stays reachable via BottomNavigation + Dashboard.
function Header({
  Text,
  title,
  hideR = "hide",
  hideL = "hide",
  LinkR,
  LinkL,
  BackFallback = "/",
  BackIcon,
  LeftIcon,
  onStartClick,
  showNotification = true,
  notificationTo = "/notifications",
  notificationLabel = "اعلان‌ها",
  showAccount = false,
  accountTo = "/UserPanel",
  accountLabel = "حساب کاربری",
}) {
  const heading = Text ?? title ?? "";
  const hasStartTarget = Boolean(LinkR);
  const hasEndTarget = Boolean(LinkL);
  const showEndAccount = showAccount && !hasEndTarget;
  const showEndNotification =
    !showEndAccount && showNotification && !hasEndTarget;

  return (
    <HeaderContainer>
      <div className="Header-side Header-side--start">
        <HeaderActions
          target={LinkR}
          fallback={BackFallback}
          icon={BackIcon}
          onClick={onStartClick}
          hidden={!hasStartTarget && hideR === "hide"}
        />
      </div>
      <h1 className="Header-title">{heading}</h1>
      <div className="Header-side Header-side--end">
        {hasEndTarget ? (
          <HeaderActions
            target={LinkL}
            fallback={BackFallback}
            icon={LeftIcon}
            hidden={hideL === "hide"}
          />
        ) : showEndAccount ? (
          <HeaderAccount to={accountTo} label={accountLabel} />
        ) : showEndNotification ? (
          <HeaderNotification to={notificationTo} label={notificationLabel} />
        ) : (
          <HeaderActions hidden />
        )}
      </div>
    </HeaderContainer>
  );
}

export default Header;
export { default as HeaderContainer } from "./HeaderContainer";
export { default as HeaderActions, HeaderBackIcon } from "./HeaderActions";
export { default as HeaderAccount, HeaderAccountIcon } from "./HeaderAccount";
export {
  default as HeaderNotification,
  HeaderNotificationIcon,
} from "./HeaderNotification";
export { default as NotificationBadge } from "./NotificationBadge";
